import React from 'react'
import { Icon } from '@manychat/manyui'

import cm from './ClosePopover.module.css'

const ClosePopover = ({ size = 16, offset = 6, offsetRight, offsetTop, onClick }) => {
  const style = { top: offsetTop || offset, right: offsetRight || offset }
  return (
    <a onClick={onClick} style={style} className={cm.wrapper}>
      <Icon.Close size={size} />
    </a>
  )
}

export default ClosePopover
